module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[52]51.72222a7.woff2";